import api from './api';

export const getBlackListEmails = (page, params) => {
  return api.get('admin/BlackList', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const getBlackListEmailsBySearch = (searchItem, search) => {
  return api.get(`admin/BlackList?searchItem=${searchItem}&search=${search}`);
};

export const addEmailToBlackList = (email, reason) => {
  return api.post('admin/blackList/addEmail', { email, reason });
};

export const removeEmailFromBackList = email => {
  return api.delete('admin/blackList/remove', { data: { email } });
};
